import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import OverViewPage from '../pages/dashboard/OverViewPage';
import RedirectPage from '../pages/dashboard/RedirectPage';
import DownloadClubRedirectPage from '../pages/download/DownloadClubRedirectPage';
import DownloadRedirectPage from '../pages/download/DownloadRedirectPage';
import DownloadStoreRedirectPage from '../pages/download/DownloadStoreRedirectPage';
import SignIn from '../pages/login/SignIn';
import AmbassadorPage from '../pages/ownersPromo/AmbassadorPage';
import OwnersPromoPage from '../pages/ownersPromo/OwnersPromoPage';
import PublicEventCheckoutPage from '../pages/publicCheckout/PublicEventCheckoutPage';
import PublicEventCheckoutSuccessPage from '../pages/publicCheckout/PublicEventCheckoutSuccessPage';
import PolicyPage from '../pages/welcome/PolicyPage';
import WelcomePage from '../pages/welcome/WelcomePage';
import { FirebaseProvider } from '../services/context/authContext';
import Layout from './Layout';

const darkTheme = createTheme({
    palette: {
        mode: 'dark'
    },
});

const AppRouter: React.FC = () => {
    return (
        <Router>
            <ThemeProvider theme={darkTheme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <FirebaseProvider>
                        <Layout>
                            <Routes>
                                <Route path="/" element={<OwnersPromoPage />} />
                                <Route path="/policy" element={<PolicyPage />} />
                                <Route path="/login" element={<SignIn />} />
                                <Route path="/overview" element={<OverViewPage />} />
                                <Route path="/events/:eventId/success" element={<PublicEventCheckoutSuccessPage />} />
                                <Route path="/events/:eventId" element={<PublicEventCheckoutPage />} />
                                <Route path="/events" element={<RedirectPage />} />
                                <Route path="/club/*" element={<DownloadClubRedirectPage />} />
                                <Route path="/event/*" element={<DownloadRedirectPage />} />
                                <Route path="/welcome" element={<WelcomePage />} />
                                <Route path="/ambassador" element={<AmbassadorPage />} />
                                <Route path="/download" element={<DownloadStoreRedirectPage />} />
                                {/* <Route path="/roulette" element={<RouletteGame />} /> */}
                            </Routes>
                        </Layout>
                    </FirebaseProvider>
                </LocalizationProvider>
            </ThemeProvider>
        </Router>
    );
}

export default AppRouter;
